<template>
  <div class="ferry-driver-select-wrapper">
    <div class="ferry-driver-select-label" v-if="label">
      <span v-if="required" class="required-asterisk">*</span>
      {{ label }}
    </div>
    <el-popover
      placement="bottom-start"
      trigger="manual"
      :width="width || 420"
      v-model="popoverVisible"
      popper-class="ferry-driver-select-popover"
    >
      <div class="ferry-driver-select-container" @click.stop>
        <div class="search-box">
          <el-input
            v-model="searchKeyword"
            placeholder="请输入司机姓名"
            size="small"
            clearable
            prefix-icon="el-icon-search"
          >
            <el-button slot="append" type="primary" size="small" @click.stop="handleSearch">
              搜索
            </el-button>
          </el-input>
        </div>
        <div class="ferry-driver-list" v-loading="loading">
          <RecycleScroller
            :items="ferryDriverList"
            :item-size="50"
            :emitUpdate="true"
            @scroll="scroll"
            v-if="ferryDriverList.length"
            key-field="driverId"
          >
            <template v-slot="{ item }">
              <div
                class="ferry-driver-item"
                :class="{ selected: isItemSelected(item) }"
                @click.stop="handleSelectItem(item)"
              >
                <div class="ferry-driver-item-content">
                  <div class="item-name">{{ item.driverInfo }}</div>
                </div>
              </div>
            </template>
          </RecycleScroller>
          <div v-if="ferryDriverList.length === 0 && !loading" class="empty-data">暂无数据</div>
        </div>
        <!--        <el-pagination-->
        <!--          v-if="ferryDriverList.length > 0"-->
        <!--          @current-change="handlePageChange"-->
        <!--          :current-page="pagination.current"-->
        <!--          :page-size="pagination.pageSize"-->
        <!--          :total="pagination.total"-->
        <!--          layout="prev, pager, next, total"-->
        <!--          class="pagination"-->
        <!--        />-->
      </div>

      <div slot="reference" class="reference-input">
        <el-input
          v-model="displayValue"
          :placeholder="placeholder || '请选择摆渡司机'"
          size="small"
          readonly
          suffix-icon="el-icon-arrow-down"
          @click.native.stop="togglePopover($event)"
        />
        <div class="selected-tags" v-if="selectedItems.length > 0 && !displayValue">
          <template v-if="collapseTags && selectedItems.length > collapseTagsLimit">
            <!-- 显示前N个标签 -->
            <el-tag
              v-for="item in selectedItems.slice(0, collapseTagsLimit)"
              :key="item.driverId"
              size="small"
              closable
              @close.stop="removeItem(item)"
            >
              {{ item.name }}
            </el-tag>

            <!-- 显示剩余数量的标签 -->
            <el-tag size="small" type="info" class="collapse-tag">
              +{{ selectedItems.length - collapseTagsLimit }}
            </el-tag>
          </template>
          <template v-else>
            <!-- 显示所有标签 -->
            <el-tag
              v-for="item in selectedItems"
              :key="item.driverId"
              size="small"
              closable
              @close.stop="removeItem(item)"
            >
              {{ item.name }}
            </el-tag>
          </template>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
  import { getFerryDriverAllList, getFerryDriverDetail } from '@/api/ferryDriver'
  import { debounce } from 'lodash'
  import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
  import { RecycleScroller } from 'vue-virtual-scroller'

  export default {
    name: 'FerryDriverSelect',
    components: {
      RecycleScroller
    },
    props: {
      value: {
        type: [String, Number, Object, Array],
        default: () => []
      },
      placeholder: {
        type: String,
        default: '请选择摆渡司机'
      },
      width: {
        type: Number,
        default: 420
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      params: {
        type: Object,
        default: () => ({})
      },
      // 是否折叠标签
      collapseTags: {
        type: Boolean,
        default: false
      },
      // 超过多少个标签时折叠显示
      collapseTagsLimit: {
        type: Number,
        default: 2
      },
      // 最大可选择的数量，0表示不限制
      maxSelections: {
        type: Number,
        default: 0
      },
      // 状态过滤
      stateFilter: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        popoverVisible: false,
        searchKeyword: '',
        ferryDriverList: [],
        loading: false,
        selectedItems: [],
        displayValue: '',
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10
        }
      }
    },
    created() {
      // 创建点击外部关闭的事件处理函数，并绑定this上下文
      this.handleDocumentClick = this.handleClickOutside.bind(this)
    },
    watch: {
      value: {
        handler(val) {
          if (!val) {
            this.displayValue = ''
            this.selectedItems = []
            return
          }

          if (Array.isArray(val)) {
            // 多选模式
            if (val.length === 0) {
              this.selectedItems = []
              this.displayValue = ''
            } else if (val.every((item) => typeof item === 'object' && item !== null)) {
              // 如果所有值都是对象，直接使用
              this.selectedItems = [...val]
              this.updateDisplayValue()
            } else {
              // 如果是ID数组，需要获取详情
              this.fetchMultipleDetails(val)
            }
          } else {
            // 单选模式
            if (typeof val === 'object' && val !== null) {
              this.selectedItems = [val]
              this.updateDisplayValue()
            } else {
              this.fetchFerryDriverDetail(val)
            }
          }
        },
        immediate: true,
        deep: true
      },
      selectedItems: {
        handler() {
          this.updateDisplayValue()
        },
        deep: true
      }
    },
    mounted() {
      if (!this.disabled) {
        this.searchFerryDrivers()
      }
      // 添加点击外部关闭下拉框的事件监听
      document.addEventListener('click', this.handleDocumentClick)
    },
    beforeDestroy() {
      // 移除事件监听，避免内存泄漏
      document.removeEventListener('click', this.handleDocumentClick)
    },
    methods: {
      searchDebounced: debounce(function () {
        this.searchFerryDrivers()
      }, 300),

      handleSearch() {
        this.pagination.current = 1
        this.ferryDriverList = this.list.filter((item) => {
          return this.searchKeyword ? item.driverInfo.includes(this.searchKeyword) : true
        })
      },

      // 处理点击外部区域关闭下拉框
      handleClickOutside(event) {
        // 如果下拉框未显示，不处理
        if (!this.popoverVisible) return

        // 获取组件元素和popover元素
        const selectWrapper = this.$el
        const popover = document.querySelector('.ferry-driver-select-popover')

        // 检查点击是否发生在组件或弹出框外部
        if (
          selectWrapper &&
          !selectWrapper.contains(event.target) &&
          !(popover && popover.contains(event.target))
        ) {
          // 点击在组件和弹出框外部，关闭弹出框
          this.popoverVisible = false
        }
      },

      // 切换下拉框显示状态
      togglePopover(e) {
        if (this.disabled) return
        // 阻止事件冒泡，防止触发外部点击事件
        e && e.stopPropagation()
        this.popoverVisible = !this.popoverVisible

        // 如果打开下拉框，重新搜索
        if (this.popoverVisible) {
          this.searchFerryDrivers()
        }
      },

      // 更新显示值
      updateDisplayValue() {
        if (this.selectedItems.length === 0) {
          this.displayValue = ''
        } else if (!this.multiple || this.selectedItems.length === 1) {
          // 单选模式或只有一个选中项时，直接显示
          const item = this.selectedItems[0]
          this.displayValue = `${item.driverInfo}`
        } else {
          // 多选时不在输入框中显示，而是使用标签显示
          this.displayValue = ''
        }
      },

      // 搜索摆渡司机
      async searchFerryDrivers() {
        this.loading = true
        try {
          const params = {
            driverInfo: this.searchKeyword || undefined,
            current: this.pagination.current,
            size: this.pagination.pageSize,
            ...this.params
          }

          const res = await getFerryDriverAllList(params)
          console.log('========', res)
          if (res.data) {
            this.ferryDriverList = res.data || []
            this.list = res.data || []
            // 首次加载自动选中第一个
            if (this.ferryDriverList.length > 0 && this.selectedItems.length === 0) {
              const first = this.ferryDriverList[0]
              this.selectedItems = [first]
              this.displayValue = first.driverInfo
              console.log('this.displayValue', this.displayValue)
              this.$emit('input', this.multiple ? [first] : first.driverId)
              this.$emit('select', this.multiple ? [first] : first)
            }
          } else {
            this.$message.error('获取司机列表失败')
            this.ferryDriverList = []
          }
        } catch (error) {
          this.$message.error('获取司机列表失败')
          this.ferryDriverList = []
        } finally {
          this.loading = false
        }
      },

      // 处理分页变更
      handlePageChange(page) {
        this.pagination.current = page
        this.searchFerryDrivers()
      },

      // 获取多个摆渡司机详情
      async fetchMultipleDetails(ids) {
        if (!ids || ids.length === 0) return

        this.loading = true
        try {
          const promises = ids.map((id) => this.fetchFerryDriverDetailWithoutLoading(id))
          const results = await Promise.all(promises)

          const validResults = results.filter((res) => res && res.data).map((res) => res.data)

          this.selectedItems = validResults
          this.updateDisplayValue()
        } catch (error) {
          console.error('获取多个详情失败：', error)
        } finally {
          this.loading = false
        }
      },

      // 不显示加载状态的详情获取
      fetchFerryDriverDetailWithoutLoading(id) {
        if (!id) return Promise.resolve(null)
        return getFerryDriverDetail(id)
      },

      // 获取摆渡司机详情
      async fetchFerryDriverDetail(id) {
        if (!id) return

        this.loading = true
        try {
          const res = await getFerryDriverDetail(id)
          if (res.data) {
            this.selectedItems = [res.data]
            this.updateDisplayValue()
          } else {
            console.warn('获取详情失败')
            this.displayValue = id
          }
        } catch (error) {
          console.error('获取详情失败：', error)
          this.displayValue = id
        } finally {
          this.loading = false
        }
      },

      // 选择一个摆渡司机
      handleSelectItem(item) {
        if (this.multiple) {
          // 多选模式
          const index = this.selectedItems.findIndex(
            (selected) => selected.driverId === item.driverId
          )

          if (index > -1) {
            // 如果已选中，则取消选中
            this.selectedItems.splice(index, 1)
          } else {
            // 如果设置了最大选择数量，且已经达到限制，则提示并返回
            if (this.maxSelections > 0 && this.selectedItems.length >= this.maxSelections) {
              this.$message.warning(`最多只能选择${this.maxSelections}项`)
              return
            }

            // 如果未选中，则添加到选中列表
            this.selectedItems.push(item)
          }

          // 发送给父组件
          this.$emit('input', [...this.selectedItems])
          this.$emit('select', [...this.selectedItems])

          // 选择后不关闭弹窗
        } else {
          // 单选模式
          this.selectedItems = [item]

          // 发送给父组件
          this.$emit('input', item.driverId)
          this.$emit('select', item)

          // 关闭弹窗
          this.popoverVisible = false
        }
      },

      // 移除选中项
      removeItem(item) {
        const index = this.selectedItems.findIndex(
          (selected) => selected.driverId === item.driverId
        )
        if (index > -1) {
          this.selectedItems.splice(index, 1)

          // 发送给父组件
          if (this.multiple) {
            this.$emit('input', [...this.selectedItems])
            this.$emit('select', [...this.selectedItems])
          } else {
            this.$emit('input', null)
            this.$emit('select', null)
          }
        }
      },

      // 检查项目是否已选中
      isItemSelected(item) {
        return this.selectedItems.some((selected) => selected.driverId === item.driverId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ferry-driver-select-wrapper {
    display: inline-block;
    width: 300px;
    position: relative;

    .ferry-driver-select-label {
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 0 10px;

      .required-asterisk {
        color: #f56c6c;
        margin-right: 4px;
      }
    }

    .reference-input {
      position: relative;
      width: 100%;
      cursor: pointer;

      .selected-tags {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 30px 0 5px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px;
        pointer-events: none;
        overflow: hidden;

        .el-tag {
          pointer-events: auto;
          margin-right: 4px;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .collapse-tag {
          background-color: #909399;
          border-color: #909399;
          color: #fff;
        }
      }
    }
  }

  ::v-deep .ferry-driver-select-popover {
    background-color: #f5f7fa;
    padding: 0;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .el-popover__title {
      margin: 0;
      padding: 10px 0;
      border-bottom: 1px solid #ebeef5;
    }

    .popper__arrow {
      display: none !important;
    }
  }

  .ferry-driver-select-container {
    .search-box {
      padding: 10px;
      background-color: #f5f7fa;

      ::v-deep .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      ::v-deep .el-button {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin: 0;
      }
    }

    .ferry-driver-list {
      max-height: 320px;
      overflow-y: auto;
      padding: 0;
      background-color: #fff;
      position: relative;

      .ferry-driver-item {
        padding: 10px 15px;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: #f5f7fa;
        }

        &.selected {
          background-color: #e6f1fc;
        }

        & + .ferry-driver-item {
          border-top: 1px solid #ebeef5;
        }

        .ferry-driver-item-content {
          .item-name {
            font-weight: bold;
            margin-bottom: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .item-info {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #909399;

            .item-status {
              display: inline-block;
              padding: 0 5px;
              border-radius: 10px;
              font-size: 12px;

              &.status-0 {
                color: #909399;
                background-color: rgba(144, 147, 153, 0.1);
              }

              &.status-1 {
                color: #e6a23c;
                background-color: rgba(230, 162, 60, 0.1);
              }

              &.status-2 {
                color: #f56c6c;
                background-color: rgba(245, 108, 108, 0.1);
              }

              &.status-3 {
                color: #67c23a;
                background-color: rgba(103, 194, 58, 0.1);
              }

              &.status-4 {
                color: #909399;
                background-color: rgba(144, 147, 153, 0.1);
              }
            }
          }
        }
      }

      .empty-data {
        padding: 30px 0;
        text-align: center;
        color: #909399;
      }

      .pagination {
        text-align: center;
        padding: 10px 0;
        background-color: #fff;
      }
    }
  }

  .scroller {
    height: 320px;
    background-color: #ccc;
  }
</style>
